import {
    useRecoilState,
    // useSetRecoilState 
} from 'recoil'
import style from './referral.module.css'
import {
    showReferralAtom,
} from '../../store'
import { useRef, useEffect, useState, useContext } from 'react'
import { getReferralLink } from '../../utils/net'
import { useTips } from '../../common/GlobalTips'
import { FaRegCopy } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { PermissionContext } from "../../utils/context";

const Referral = () => {
    const [showReferral, setShowReferral] = useRecoilState(showReferralAtom)
    const [referralLink, setReferralLink] = useState('')
    const { t } = useTranslation();
    const tip = useTips(null)
    const ref = useRef(null)
    const { isAllowedTo } = useContext(PermissionContext);

    const handlerClose = () => {
        if (ref.current && ref.current.contains(event.target)) return
        if (window.history.length <= 1) {
            const url = new URL(window.location.href)
            url.pathname = "/"
            // window.history.pushState(null, null, url);
        }
        else {
            window.history.back()
        }
        setShowReferral(false)
    }

    const handlerGetReferralLink = async () => {
        // TODO: acquiring a lock and waiting for authorization to be established before proceeding with a request
        if (!isAllowedTo("referral.feature")) {
            return;
        }

        const res = await getReferralLink()

        if (!res) {
            tip({
                type: 'error',
                content: t('TIP_ERR_REFERRAL_GET_LINK')
            })
            return
        }
        if (res.data?.link) return res.data.link.replace('https://hyperhuman.top', 'https://3d.app')
        else if (res.data?.error) {
            switch (res.data.error) {
                case 'REFERRER_BANNED':
                    tip(
                        {
                            type: 'error',
                            content: t('TIP_ERR_REFERRAL_ACC_BAN')
                        }
                    )
                    break
                default:
                    tip(
                        {
                            type: 'error',
                            content: t('TIP_ERR_REFERRAL_GET_LINK')
                        }
                    )
                    break
            }
        }
    }

    const handlerCopyReferralLink = async () => {
        navigator.clipboard.writeText(referralLink)
        tip(
            {
                type: 'primary',
                content: t('TIP_PRIMARY_REFERRAL_CLIP')
            }
        )
        ReactGA.event({ category: 'Referral', action: 'copy_referral_link' })
    }

    const handlerTwitterShare = () => {
        const msg = `Try closest to production-ready AI 3D Generator from @DeemosTech. Get bonus 50% credits for #Hyper3d #Rodin #ChatAvatar using my link:  ${referralLink}`;
        const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(msg)}`
        window.open(url, '_blank', 'width=600,height=600')
    }

    useEffect(() => {
        const fetchReferralLink = async () => {
            if (localStorage.getItem('user_uuid') === null) return
            try {
                const link = await handlerGetReferralLink();
                setReferralLink(link);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchReferralLink();
    }, [])

    if (!showReferral) return null

    return (
        <div className={style.referralMask} onClick={handlerClose}>
            <div className={style.referralContent} ref={ref}>
                <div className={style.referralBody}>
                    <div className={style.referralHeaderPrimary}>{t('WALLET_REF_HEAD_MAIN')}</div>
                    <div className={style.referralHeaderSecondary}>{t('WALLET_REF_HEAD_SIDE')}</div>
                    <div className={style.referralText}>
                        <p>{t('WALLET_REF_TITLE_1')}</p>
                        <p>{t('WALLET_REF_TITLE_2')}</p>
                    </div>
                    <div className={style.referralLink}>
                        <input type="text" value={referralLink} readOnly className={style.referralLinkContent} onClick={handlerCopyReferralLink} />
                        <button onClick={handlerCopyReferralLink}><FaRegCopy /></button>
                    </div>
                    <div className={style.referralDisclaimer}>{t('WALLET_REF_SIDE_TITLE')}</div>
                    <div className={style.referralShare}>
                        <p>{t('WALLET_REF_SHARE_TITLE')}</p>
                        <FaTwitter onClick={handlerTwitterShare} className={style.referralShareIcon} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export { Referral }